import * as React from 'react';
import styled from '@emotion/styled';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export type SearchFieldWidgetProps = React.ComponentPropsWithoutRef<'input'>;

export const SearchFieldWidget = React.forwardRef<HTMLInputElement, SearchFieldWidgetProps>(
  ({ className, ...props }, ref) => (
    <S.Root className={className}>
      <S.Icon icon={faMagnifyingGlass} aria-hidden="true" />
      <S.Input type="search" {...props} ref={ref} />
    </S.Root>
  )
);

namespace S {
  export const Root = styled.div`
    box-sizing: border-box;
    display: flex;
    align-items: center;
    min-width: 0;
    width: 100%;
    background: ${(p) => p.theme.header.searchBackground};
    border: 1px solid ${(p) => p.theme.header.searchBorder};
    border-radius: 14px;
    box-shadow: ${(p) => p.theme.card.shadow};

    &:focus-within {
      border-color: ${(p) => p.theme.text.special};
    }
  `;

  export const Icon = styled(FontAwesomeIcon)`
    color: ${(p) => p.theme.header.searchPlaceholder};
    font-size: 13px;
    flex-shrink: 0;
    margin-left: 14px;
    pointer-events: none;
  `;

  export const Input = styled.input`
    box-sizing: border-box;
    background: transparent;
    border: 0;
    border-radius: inherit;
    color: ${(p) => p.theme.header.textColor};
    font: inherit;
    font-size: 14px;
    line-height: 1;
    padding: 11px 14px 11px 10px;
    width: 100%;
    min-width: 0;
    outline: none;

    &::placeholder {
      color: ${(p) => p.theme.header.searchPlaceholder};
      opacity: 1;
    }

    &:disabled {
      cursor: not-allowed;
      opacity: 0.8;
    }

    &::-webkit-search-cancel-button {
      display: none;
    }
  `;
}
